export class LocalizationModel {
  /**
  * The ID of the entity.
  */
  id: number;

  /**
   * The description.
   */
  description: string;

  /**
   * The isDefault flag.
   */
  isDefault: boolean;

  /**
   * The locale.
   */
  locale: string;

  /**
   * The locale id.
   */
  localeId: number;

  /**
   * The active status.
   */
  isActive: boolean;

  /**
   * The user id of the creator.
   */
  createdBy: number;

  /**
   * The user description of the creator.
   */
  createdByDescription: string;

  /**
   * The creation date.
   */
  createdOn: Date;

  /**
   * The user id of the modifier.
   */
  modifiedBy: number;

  /**
   * The user description of the modifier.
   */
  modifiedByDescription: string;

  /**
   * The modified date.
   */
  modifiedOn: Date;

  /**
   * The number format.
   */
  numberFormat: string;

  /**
   * The date format.
   */
  dateFormat: string;

  /**
   * The currency format identifier.
   */
  currencyFormat: number;

  /**
   * Constructor
   */
  constructor(data?: any) {
    this.id = data?.id ?? -1;
    this.description = data?.description ?? "";
    this.isDefault = data?.isDefault;
    this.isActive = data?.isActive;
    this.localeId = data?.localeId ?? 0;
  }
}
